import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const DeleteEndpoint = ApiEndpoints.video.Delete;
const ListEndpoint = ApiEndpoints.video.List;
const EditPath = "edit-video";
const tableHeader = ["Date","Title","URL"];
const tbody = ["createdAt","title","video_url"];

export default function VideoListing() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ListEndpoint);
      const result = response.videos;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (video_id) => {
      const payload = { video_id };
      try {
        const response = await ApiRequest("POST", DeleteEndpoint, payload);
        toast.success(response.message)
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    };

    const pagename = {
      name: 'Video Management',
      user: 'Admin',
      innerpage: 'Video Management / Videos'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-video">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={EditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
